import React from 'react';
import '../styles/aboutUs.css'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

const About = () => {
    return (
        <div className="about-section gray-bg">
            <div className="row justify-content-center" ><h1>About Us</h1>
                <div className="body col-md-5 col-sm-5">
                    <div className="about-title" data-aos="zoom-in">
                        <h5>Vision</h5>
                        <ul>
                            <li>To be the company of choice for quality clients , and to deliver the best integrated communications solutions.</li>
                            <li>To be a platform that that will expose Eastern Cape talent to the world</li>
                        </ul>
                        <h5>Mission</h5>
                        <ul>
                            <li>To offer clients top-quality, innovative integrated communications solutions.</li>
                            <li>To build long term, value adding relationships with our clients, based on knowledge of their business strategies, imperatives and needs.</li>
                            <li>To build long term relationships with our business partners, ensuring that together we best meet the needs of the client and the goals of our businesses.</li>
                            <li>To build and retain a skilled, sustainable and effective team of qualified people who are committed to Flow's vision and mission.</li>
                        </ul>
                    </div>
                </div>
                <div className="contactInf col-md-5 col-sm-5" data-aos="zoom-in">
                    <div className="contact-item">
                        <h5>Contact Info</h5>
                        <p>
                            <span>
                                <i className="fa fa-map-marker"></i> 1353 Nu 17, Mdantsane, Eastern Cape, 5219
                            </span>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2554.5191707726867!2d27.691299115186457!3d-32.953589880919104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e66c3085f763989%3A0xc6020aacdca9622e!2s1353%20Nu%2017%2C%20Mdantsane-R%2C%20Mdantsane%2C%205219!5e1!3m2!1sen!2sza!4v1632654159192!5m2!1sen!2sza" width="100%" height="100%" allowFullScreen={true} loading="lazy" title='map'></iframe>
                        </p>

                        <div className="contact-item">
                            <p>
                                <span>
                                    <i className="fa fa-phone"></i> Phone
                                </span>{" "}
                                084 206 5734/ 063 149 9742
                            </p>
                        </div>
                        <div className="contact-item">
                            <p>
                                <span>
                                    <i className="fa fa-envelope-o"></i> Email
                                </span>{" "}
                                3psagency@gmail.com
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About